import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isSubscriptionFeatureEnabled } from '../../features/subscription-feature';
import { ERoutes } from '../../enums';

export const subscriptionFeatureGuard: CanActivateFn = () => {
  if (isSubscriptionFeatureEnabled()) {
    return true;
  }

  return inject(Router).createUrlTree([`/${ERoutes.basicInfo}`]);
};
